enum PageUrl {
  HOME = '/',
  LOGIN = '/login',
  LOGOUT = '/logout',
  AUDIODATA = '/audiodata',
  CHARITYDATA = '/charitydata'
}

export default PageUrl;
